module.exports = __webpack_public_path__ + "static/10-Dish with flower attached-d3a037ff32a7e327cbb8e039afd6e4e4.jpg";